import { Component } from 'react';
import PropTypes from 'prop-types';
import CollapseFieldWrapper from './shared/CollapseFieldWrapper';
import DateInput from '../inputs/DateInput';
import { jsx as _jsx } from "react/jsx-runtime";
export default class DateField extends Component {
  render() {
    const {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      autoFocus,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      collapsed,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      disabled,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      formData,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      idSchema,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      isAdditionalProperty,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      name,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      onChange,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      readOnly,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      registry,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      required,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      schema
    } = this.props;
    const {
      title
    } = schema;
    const {
      formContext
    } = registry;
    return /*#__PURE__*/_jsx(CollapseFieldWrapper, {
      collapsed: collapsed,
      formData: formData,
      isAdditionalProperty: isAdditionalProperty,
      children: /*#__PURE__*/_jsx(DateInput
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
        autoFocus: autoFocus,
        formContext: formContext,
        id: idSchema && idSchema.$id,
        disabled: disabled,
        label: title || name,
        onChange: onChange,
        readOnly: readOnly,
        required: required,
        schema: schema,
        value: formData || ''
      })
    });
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
DateField.propTypes = {
  autoFocus: PropTypes.bool,
  collapsed: PropTypes.bool,
  disabled: PropTypes.bool,
  formData: PropTypes.any,
  idSchema: PropTypes.object,
  isAdditionalProperty: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  readOnly: PropTypes.bool,
  registry: PropTypes.object,
  required: PropTypes.bool,
  schema: PropTypes.object
};